import "./style.css";
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../../Assets/Images/Lendriva_logo.jpg";
import righticon from "../../Assets/Images/right-icon.png";
import svg_expiry from "../../Assets/Images/svg_expiry.svg";

const OtpVerifySuccessfully = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const status = location.state?.status || "success";
    const userRole = location.state?.roleType || "borrower";

    const [selectedUserType, setSelectedUserType] = useState<
        "borrower" | "lender"
    >("borrower");
    useEffect(() => {
        const loginPage = document.querySelector(".onboarding-page");

        if (loginPage) {
            loginPage.classList.remove("theme-borrower", "theme-lender");
            loginPage.classList.add(`theme-${userRole}`);
        }
    }, [userRole]);
    useEffect(() => {
        if (userRole === "borrower" || userRole === "lender") {
            setSelectedUserType(userRole);
        }
    }, [userRole]);

    const renderMessage = () => {
        switch (status) {
            case "already_verified":
                return {
                    icon: svg_expiry,
                    message: "Email has already been verified!",
                };
            default:
                return {
                    icon: righticon,
                    message: "Email successfully verified! You can now log in.",
                };
        }
    };

    const { icon, message } = renderMessage();

    return (
        <div className="row onboarding-page m-0 p-0">
            <div className="container-fluid reset-pw">
                <div className="password-success-blk d-flex flex-column">
                    <div className="close-icon cursor-pointer text-end">
                        <Link to="/auth/login">
                            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M15.75 9.845L13.058 12.5L15.75 15.155C15.825 15.225 15.885 15.31 15.926 15.404C15.967 15.498 15.988 15.6 15.988 15.703C15.988 15.805 15.967 15.907 15.926 16.001C15.885 16.095 15.825 16.18 15.75 16.25C15.68 16.319 15.597 16.375 15.506 16.412C15.414 16.449 15.316 16.468 15.218 16.468C15.021 16.467 14.832 16.389 14.693 16.25L12 13.558L9.345 16.25C9.206 16.389 9.017 16.467 8.82 16.468C8.722 16.468 8.624 16.449 8.532 16.412C8.441 16.375 8.358 16.319 8.288 16.25C8.148 16.11 8.07 15.919 8.07 15.721C8.07 15.523 8.148 15.333 8.288 15.193L10.943 12.5L8.288 9.845C8.165 9.702 8.101 9.517 8.108 9.328C8.115 9.139 8.193 8.96 8.327 8.827C8.461 8.693 8.64 8.615 8.828 8.608C9.017 8.6 9.202 8.665 9.345 8.788L12 11.443L14.655 8.788C14.725 8.716 14.808 8.658 14.899 8.618C14.991 8.578 15.089 8.557 15.189 8.555C15.289 8.553 15.389 8.571 15.482 8.608C15.575 8.645 15.66 8.699 15.732 8.769C15.803 8.838 15.861 8.921 15.901 9.013C15.941 9.104 15.962 9.203 15.964 9.303C15.966 9.403 15.948 9.502 15.911 9.595C15.874 9.688 15.82 9.773 15.75 9.845Z"
                                    fill="black"
                                />
                            </svg>
                        </Link>
                    </div>
                    <div className="lower-div mx-auto">
                        <div className="row">
                            <div className="col text-center logo-fit">
                                <img src={logo} alt="logo" className="img-fluid" />
                            </div>
                        </div>
                        <div className="row ">
                            <div className="col">
                                <div className="pw-success-box">
                                    <div className="right-icon">
                                        <img src={icon} alt="status-icon" className="img-fluid" />
                                    </div>
                                    <p className="mt-4 pw-successtext text-center">{message}</p>
                                    {/* <Link to="/auth/login"> */}
                                    <button
                                        onClick={() => navigate("/auth/login", {
                                            state: { roleType: selectedUserType },
                                        })}
                                        type="button"
                                        className="btn btn-borrower signin w-100 border-radius mt-3"
                                    >
                                        Login
                                    </button>
                                    {/* </Link> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OtpVerifySuccessfully;
